import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class BinHdrQueryCriteriaClass extends BaseCriteriaModel {
  guid_branch?: Optional<string> = Optional.empty();
  guid_location?: Optional<string> = Optional.empty();
  bin_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();

}

export class BinHdrCriteriaModelQuery {
  query = '';

  constructor(binHdrCriteriaModel: BinHdrQueryCriteriaClass) {

    if (!binHdrCriteriaModel) {
      return;
    }

    this.query += binHdrCriteriaModel.guid_branch.filter(x => x !== '').map(x => '&guid_branch=' + x).orElse('');
    this.query += binHdrCriteriaModel.guid_location.filter(x => x !== '').map(x => '&guid_location=' + x).orElse('');
    this.query += binHdrCriteriaModel.bin_type.filter(x => x !== '').map(x => '&bin_type=' + x).orElse('');
    this.query += binHdrCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += binHdrCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');

    this.query += '&status=' + binHdrCriteriaModel.status;
    this.query += '&orderBy=' + binHdrCriteriaModel.orderBy;
    this.query += '&order=' + binHdrCriteriaModel.order;
    this.query += '&offset=' + binHdrCriteriaModel.offset + '&limit=' + binHdrCriteriaModel.limit;
  }
}

